module.exports = __webpack_public_path__ + "static/img/function_0.303da51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/function_0.png
// module id = ttuk
// module chunks = 1